module.exports = __webpack_public_path__ + "img/diapositiva-5-2.eb93faf0.png";